import router from './router'
import getPageTitle from '@/utils/get-page-title'
import { getToken } from '@/utils/auth'
router.beforeEach((to, from, next) => {
    document.title = getPageTitle(to.meta.title)
    const hasToken = getToken()
    if (hasToken) {
        if (to.path === '/login') {
            next({ path: '/' })
        } else {
            next()
        }
    } else {
        next()
    }
})




// WEBPACK FOOTER //
// ./src/permission.js